var _style, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _ellipse4, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa03ddf9-f8f2-4819-a4ce-be9b0a220741",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1119.6 699",
    style: {
      enableBackground: "new 0 0 1119.6 699"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#3f3d56}.st2{opacity:.1;enable-background:new}.st3{fill:none;stroke:#2f2e41;stroke-width:2;stroke-miterlimit:10}.st4{fill:#2f2e41}.st5{fill:#f2f2f2}.st6{fill:#feee00}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 201.1,
    r: 198.2,
    style: {
      fill: "#f9f9f9"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 231.5,
    cy: 399.1,
    rx: 187,
    ry: 25.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 231.5,
    cy: 399.1,
    rx: 157,
    ry: 21.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 836.6,
    cy: 660.5,
    rx: 283,
    ry: 38.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M462.6 626c90 23 263-30 282-90M266.7 259.1s80.6-36.7 85.5 81.5-66.3 151.8-10.5 175.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m778.7 563.2-7.9 50.3s-38.8 20.6-11.5 21.2 155.7 0 155.7 0 24.8 0-14.5-21.8l-7.9-52.7-113.9 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.8 634.2c6.2-5.5 17-11.3 17-11.3l7.9-50.3 113.9.1 7.9 49.6c9.2 5.1 14.9 9 18.2 12 5.1-1.2 10.6-5.4-18.2-21.4l-7.9-52.7-113.9 3-7.9 50.3s-32.6 17.3-17 20.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M596.5 212.7h477.2c10 0 18 8.1 18 18v321.4c0 10-8.1 18-18 18H596.5c-10 0-18-8.1-18-18V230.7c-.1-9.9 8-18 18-18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M595.7 231.8h478.7v267.8H595.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 835.1,
    cy: 223.3,
    r: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1091.7 520.8v31.3c0 10-8.1 18-18 18H596.5c-10 0-18-8.1-18-18v-31.3h513.2zM969 667.5v6H643v-4.8l.4-1.2 8.1-21.8h310.8zM1094.4 661.5c-.6 2.5-2.8 5.2-7.9 7.8-18.2 9.1-55.1-2.4-55.1-2.4s-28.5-4.8-28.5-17.6c.8-.5 1.6-1 2.5-1.5 7.6-4 33-14 77.9.4 3.3 1 6.3 3 8.5 5.6 1.9 2.2 3.3 4.9 2.6 7.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1094.4 661.5c-22.3 8.5-42.1 9.2-62.4-5-10.3-7.1-19.6-8.9-26.6-8.8 7.6-4 33-14 77.9.4 3.3 1 6.3 3 8.5 5.6 1.9 2.3 3.3 5 2.6 7.8z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 1066.5,
    cy: 654.1,
    rx: 7.9,
    ry: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 835.1,
    cy: 545.7,
    r: 11.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M969 667.5v6H643v-4.8l.4-1.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.8 21.4h173.6v375.5H93.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.8 37.8h133.6v39.4H113.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.2 62.3h-33.3c-.4 0-.8-.4-.8-.8v-7.9c0-.4.4-.8.8-.8h33.3c.4 0 .8.4.8.8v7.9c0 .4-.3.8-.8.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.8 87.9h133.6v39.4H113.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.2 112.4h-33.3c-.4 0-.8-.4-.8-.8v-7.9c0-.4.4-.8.8-.8h33.3c.4 0 .8.4.8.8v7.9c0 .4-.3.8-.8.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.8 138h133.6v39.4H113.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.2 162.5h-33.3c-.4 0-.8-.4-.8-.8v-7.9c0-.4.4-.8.8-.8h33.3c.4 0 .8.4.8.8v7.9c0 .4-.3.8-.8.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.8 188.7h133.6v193H113.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.2 213.1h-33.3c-.4 0-.8-.4-.8-.8v-7.9c0-.4.4-.8.8-.8h33.3c.4 0 .8.4.8.8v7.9c0 .5-.3.8-.8.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.4 676.4c0 6.3-22.2 11.8-54.5 14.4-13.5 1.1-28.8 1.8-45.1 1.8-16.2 0-31.5-.6-45.1-1.8-32.4-2.7-54.5-8.1-54.5-14.4s22.2-11.8 54.5-14.5c13.5-1.1 28.8-1.8 45.1-1.8 16.2 0 31.5.6 45.1 1.8 32.3 2.8 54.5 8.2 54.5 14.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.531,
    y1: 13.32,
    x2: 402.74,
    y2: 88.046,
    gradientTransform: "matrix(1 0 0 -1 0 699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#242934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2f3440"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.8 639.2v51.7c-13.5 1.1-28.8 1.8-45.1 1.8-16.2 0-31.5-.6-45.1-1.8v-51.7c0-24.9 20.2-45.1 45.1-45.1 12.4 0 23.7 5 31.9 13.2s13.2 19.4 13.2 31.9z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 375.346,
    cy: 51.636,
    r: 15.177,
    gradientTransform: "matrix(1 0 0 -1 0 699)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    style: {
      stopColor: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    style: {
      stopColor: "#e1e2e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#d4d5da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#c2c4cb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#aaaeb9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a2a6b3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 374.3,
    cy: 649.9,
    r: 10.3,
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.389,
    y1: 47.7,
    x2: 377.178,
    y2: 47.7,
    gradientTransform: "matrix(1 0 0 -1 0 699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#242934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2f3440"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 374.3,
    cy: 651.3,
    r: 2.9,
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 336.366,
    cy: 51.636,
    r: 15.177,
    gradientTransform: "matrix(1 0 0 -1 0 699)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    style: {
      stopColor: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    style: {
      stopColor: "#e1e2e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#d4d5da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#c2c4cb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#aaaeb9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a2a6b3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 335.3,
    cy: 649.9,
    r: 10.3,
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.409,
    y1: 46.2,
    x2: 338.197,
    y2: 46.2,
    gradientTransform: "matrix(1 0 0 -1 0 699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#242934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2f3440"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 335.3,
    cy: 652.8,
    r: 2.9,
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m423.8 610.7-141.7 44.5.6-35.6.4-22.2.1-8.1.7-39.9.5-30.3.6-36.9c0-2.9 1.9-5.4 4.7-6.2l25.7-8c2.7-.9 5.7.1 7.4 2.5l21.6 30 17.7 24.6 23.3 32.4 4.8 6.6 13 18 20.6 28.6zM452.7 614.3l-192.1 60.3c-3.2 1-6.5-.8-7.5-3.9-1-3.2.8-6.5 3.9-7.5l192.1-60.3c3.2-1 6.5.8 7.5 3.9 1 3.1-.8 6.5-3.9 7.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.23,
    y1: 790.445,
    x2: 518.98,
    y2: 827.187,
    gradientTransform: "scale(1 -1) rotate(17.422 4755.105 -378.826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b5bac7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    style: {
      stopColor: "#b8bdc9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#d7dae1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#edeef1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    style: {
      stopColor: "#fafbfc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "m362 524.9-78.1 24.5.5-30.3 59.9-18.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.783,
    y1: 744.91,
    x2: 541.885,
    y2: 744.91,
    gradientTransform: "scale(1 -1) rotate(17.422 4755.105 -378.826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b5bac7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    style: {
      stopColor: "#cdd1d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    style: {
      stopColor: "#e3e5ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    style: {
      stopColor: "#f3f4f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#fcfcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "m403 581.8-120.3 37.8.5-30.3 102.1-32.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.815,
    y1: 681.888,
    x2: 478.815,
    y2: 722.806,
    gradientTransform: "scale(1 -1) rotate(17.422 4755.105 -378.826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8d6c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    style: {
      stopColor: "#ac9487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#c9bab1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    style: {
      stopColor: "#e1d8d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    style: {
      stopColor: "#f1eeeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    style: {
      stopColor: "#fcfbfa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "m423.8 610.7-141.7 44.5.6-35.6.4-22.2 107-33.6 12.9 18z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error-image.b0dc84f1a99fd043f942e28fb0dcd7e5.svg";
export { ForwardRef as ReactComponent };